import React from "react";
import { useParallax } from "react-scroll-parallax";

const CompanyArea = ({content}) => {
  const parallax = useParallax({
    translateX: [-24, 24],
    rootMargin: 0,
  });

  return (
    <section className="company-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title white-title text-center mb-65">
              <span className="sub-title">Our Company</span>
              <h2 className="title">
                {content.h2}
              </h2>
              <p style={{ width: "100%" }}>
                {content.para}
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="company-img">
              <img src="/img/images/company_img01.png" alt="" />
              <img
                src="/img/images/company_img02.png"
                alt=""
                data-parallax='{"x" : 120 }'
                ref={parallax.ref}
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="company-content">
              <h2 className="title">{content.h3}</h2>
              <div className="company-list">
                <p style={{ color: "#c7c7c7", marginBottom: "2rem" }}>
                  {content.h3Para}
                </p>
              </div>
              <a href="about-me.html" className="btn">
                Discover More <span></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="company-shape-wrap">
        <img src="/img/images/company_shape.png" alt="" />
      </div>
    </section>
  );
};

export default CompanyArea;
